import { Route } from '@angular/router'
import { TaxonomyDetailComponent } from '../taxonomy-detail/taxonomy-detail.component'
import { createTaxonomyDefinition } from '../taxonomy-detail/taxonomy.definition'

import { PermissionGuard } from '../../abacus/guards/permission.guard'
import { AuthGuard } from '../../abacus/guards/auth.guard'

import { LicenseListComponent } from './license-list/license-list.component'

export const licenseRoutes: Route[] = [
  {
    path: 'licenses',
    component: LicenseListComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      permission: 'browseTaxonomies'
    }
  },
  {
    path: 'licenses/:id/edit',
    redirectTo: 'licenses/:id',
    pathMatch: 'full'
  },
  {
    path: 'licenses/:id',
    component: TaxonomyDetailComponent,
    canActivate: [AuthGuard, PermissionGuard],
    data: {
      definition: createTaxonomyDefinition({
        className: 'License',
        nameSingular: 'License',
        namePlural: 'Licenses',
        path: 'licenses',
        slug: 'taxonomies/licenses',
        title: 'Licenses'
      }),
      permission: 'readTaxonomies'
    }
  }
]
